import clsx from 'clsx';
import { createContext, PropsWithChildren, useRef, useState } from 'react';

export const ToastContext = createContext<(message: string) => void>(() => {});

export const ToastProvider = ({ children }: PropsWithChildren) => {
  const [showsToast, setShowsToast] = useState(false);
  const [fadesOutToast, setFadesOutToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const toastHideTimerId = useRef<number | undefined>(undefined);

  const toast = (message: string) => {
    clearTimeout(toastHideTimerId.current);
    setToastMessage(message);
    setShowsToast(true);
    toastHideTimerId.current = window.setTimeout(() => {
      setFadesOutToast(true);
    }, 3000);
  };

  return (
    <ToastContext.Provider value={toast}>
      {showsToast && (
        <div
          role='alert'
          className={clsx('toast', {
            ['opacity-0 transition-all duration-300']: fadesOutToast,
          })}
          onTransitionEnd={() => {
            if (!fadesOutToast) {
              return;
            }
            setShowsToast(false);
            setFadesOutToast(false);
          }}
        >
          <div className='fixed left-0 top-0 z-[99999] flex h-[30px] w-full items-center justify-center gap-[10px] bg-primary-500 text-white'>
            <div className='size-[14px]'>
              <svg
                width='14'
                height='14'
                viewBox='0 0 14 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M5.57061 10.4999L2.24561 7.17494L3.07686 6.34369L5.57061 8.83744L10.9227 3.48535L11.7539 4.3166L5.57061 10.4999Z'
                  fill='white'
                />
              </svg>
            </div>
            <span className='text-sm'>{toastMessage}</span>
          </div>
        </div>
      )}
      {children}
    </ToastContext.Provider>
  );
};
